import { ArtistPage } from '@services/artist/types/artist-page';

export const blankArtistPage = (): ArtistPage => ({
  id: '',
  theme: 'light',
  images: [],
  home: {
    platforms: []
  },
  music: {
    trackLinks: [],
    releases: []
  },
  contact: {
    networks: []
  },
  videos: {
    list: []
  },
  merch: {
    list: []
  }
});